import { useMutation, useQueryClient } from 'react-query'
import { useHistory } from 'react-router'
import { useParams } from 'react-router-dom'
import { generatePath } from 'react-router-dom'
import { routes } from '../router/routes'
import apiService from '../services/api'
import { apiURL } from '../services/api/apiURL'
import { useUser } from './useUser'

export const useRegisterInfluencer = (mode = 'create') => {
  const { user, isAdmin } = useUser()
  const queryClient = useQueryClient()
  const history = useHistory()
  const { id } = useParams()

  const registerInfluencer = async args => {
    const uri =
      mode === 'create'
        ? apiURL.auth.registerInfluencer
        : apiURL.influencers.getInfluencerById(isAdmin ? id : user._id)
    const method = mode === 'create' ? 'post' : 'patch'
    return await apiService[method](uri, args)
  }
  return useMutation(registerInfluencer, {
    onSuccess: async () => {
      if (mode === 'update') {
        await queryClient.invalidateQueries(['influencers', 'view', user._id])
        isAdmin
          ? history.push(generatePath(routes.adminViewInfluencer, { id }))
          : history.push(routes.influencerProfile)
      }
    },
    onError: () => {}
  })
}
